import { useQuery, useMutation } from '@tanstack/react-query';
import { plansService, getSubscriptionStatus, type SubscribePayload } from '@/services/plans';
import apiClient from '@/services/api';

export function usePlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: () => plansService.getPlans(),
    staleTime: 5 * 60_000,
  });
}

export function useSubscribePlan() {
  return useMutation({
    mutationFn: (payload: SubscribePayload) => plansService.subscribe(payload),
  });
}

export function useVerifyPayment(ref: string | null) {
  return useQuery({
    queryKey: ['payment-verify', ref],
    queryFn: () => plansService.verifyPayment(ref!),
    enabled: !!ref,
    retry: 3,
    retryDelay: 2000,
    staleTime: 0,
  });
}

export function useBillingHistory() {
  return useQuery({
    queryKey: ['billing-history'],
    queryFn: () => apiClient.get('/payments/billing').then((r) => r.data),
    staleTime: 60_000,
  });
}

/** The organisation's plan limits, usage and lapse/grace state. */
export function useSubscriptionStatus() {
  return useQuery({
    queryKey: ['subscription-status'],
    queryFn: getSubscriptionStatus,
    staleTime: 60_000,
  });
}
